import React, { useState } from 'react';
import { Form, Input } from '@rocketseat/unform';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';

// Imagens e Logos
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import vetorTartaruga from '~/assets/vetor-tartaruga.png';
import backgroundMobile from '~/assets/apolino-bg-mobile.jpg';
import backgroundDesktop from '~/assets/apolino-bg-desktop.webp'; // <-- Nova importação

import { documentMask } from '~/util/documentInputMask';
import { authDocument } from '~/store/modules/auth/actions';

// Estilos
import { MobileLayout, Loader, GlobalFonts } from './styles';

const schema = Yup.object().shape({
  document: Yup.string().required('É obrigatório preencher o documento.'),
});

export default function SignIn() {
  const [document, setDocument] = useState('');
  const loading = useSelector(state => state.auth.loading);
  const dispatch = useDispatch();

  async function handleSubmit() {
    dispatch(authDocument(document));
  }

  function handleIndicarClick() {
    window.open('https://www.apolar.com.br/indique?utm_source=site-interno&utm_medium=botao-clique&utm_campaign=area-do-cliente', '_blank');
  }

  return (
    <>
      <GlobalFonts />
      <MobileLayout bgMobile={backgroundMobile} bgDesktop={backgroundDesktop}>

        <div class="top-section-container">
          {/* === SEÇÃO SUPERIOR (LOGIN) === */}
          <div className="top-section">
            <img src={logo} alt="Logo Apolar Imóveis" className="logo" />
            <img src={vetorTartaruga} alt="Vetor Tartaruguinha" className="logo-mobile" />

            <h1 className="title-desktop">Login</h1>

            <h1 className="title">ÁREA DO CLIENTE</h1>
            <h2 className="subtitle">Conecte-se</h2>
            <p className="instruction">Digite o número do seu documento</p>

            <Loader style={{ display: loading ? 'block' : 'none' }} />

            <Form schema={schema} onSubmit={handleSubmit}>
              <Input
                maxLength="18"
                name="document"
                placeholder="CPF ou CNPJ"
                value={document}
                onChange={e => {
                  setDocument(documentMask(e.target.value));
                }}
              />
              <button type="submit" className="btn-proximo">PRÓXIMO</button>
            </Form>
          </div>

          {/* === SEÇÃO INFERIOR (EMBAIXADOR) === */}
          <div className="bottom-section">
            <h2 className="ambassador-title">
              Seja embaixador(a)<br />da Apolar!
            </h2>
            <p className="ambassador-subtitle">Crie sua própria rede.</p>
            <button
              type="button"
              className="btn-indicar"
              onClick={handleIndicarClick}
            >
              INDICAR AGORA
            </button>
          </div>
        </div>


      </MobileLayout>
    </>
  );
}